// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"85":"mobile","524":"app","933":"auth"}[chunkId] || chunkId) + "." + {"85":"b32d9185","140":"a27caa26","523":"1ffe7e97","524":"6898fd60","573":"a82f069e","933":"e8092cf1"}[chunkId] + ".chunk.js";
};